import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: _ctx.title,
    class: "medium",
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        type: "date",
        value: _ctx.state.take_date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.take_date) = $event)),
        placeholder: "Выберите новую дату",
        disabled: _ctx.loading,
        "is-invalid": _ctx.validation$.take_date.$error,
        "validation-errors": _ctx.validation$.take_date.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        placeholder: "Период отправки",
        value: _ctx.state.periodId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.periodId) = $event)),
        loading: _ctx.data_state.periods.is_loading,
        failed: _ctx.data_state.periods.is_failed,
        "error-text": "При получении списка периодов произошла ошибка",
        searchable: false,
        options: _ctx.data_state.periods.list,
        onRefresh: _ctx.loadPeriods,
        label: "title"
      }, null, 8, ["value", "loading", "failed", "options", "onRefresh"])
    ]),
    _: 1
  }, 8, ["title", "loading", "onSubmit", "onCancel"]))
}